export default __webpack_public_path__ + "static/media/HAiReport_color_vertical.242c87ca.svg";